import { MinorSections } from './minor-sections.enum';

export const MinorSectionsTitles = {
  [MinorSections.Home]: 'Guardianship Home',
  [MinorSections.Subscriber]: 'Subscriber (YOUR) information',
  [MinorSections.MinorsDetails]: "Minor's Details",
  [MinorSections.Assets]: `Minor's Estates Details`,
  [MinorSections.Documents]: 'Documents',
  [MinorSections.Forms]: 'Forms',
  [MinorSections.Taxes]: 'Financials/Assets Tax Details',
  [MinorSections.BondSurety]: 'Bond/Surety Details',
  [MinorSections.Notes]: 'Notes',
  [MinorSections.Notifications]: 'Notifications',
  [MinorSections.Messages]: 'Messages',
} as const;
